import React from 'react';
import { Card, CardBody } from 'reactstrap';
import {
  PatientComment,
  RxComment,
  EncounterComment,
  ProviderComment,
} from 'components/Comments';

const GlobalComments = ({ row, tenantID, coveredEntityID }) => {
  return (
    <>
      <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <PatientComment
            patientID={row?.patientID}
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
          />
        </CardBody>
      </Card>
      <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <RxComment
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
            rxNumber={row?.rxNumber}
          />
        </CardBody>
      </Card>
      <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <ProviderComment
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
            providerID={row?.providerID}
          />
        </CardBody>
      </Card>
      <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <EncounterComment
            tenantID={tenantID}
            encounterID={row?.encounterID}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default GlobalComments;
